import React from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from '@thd-olt-component-react/core-ui';
import { useStore } from '../../../store';

const ErrorAlert = observer(() => {
  const {
    notificationStore: { error, setError }
  } = useStore();

  return (
    error && (
      <div style={{ padding: '15px' }}>
        <Alert type="danger" title="Error: " message={error} dismiss={() => setError(null)} />
      </div>
    )
  );
});

export default ErrorAlert;
